import React from 'react';
import './SummaryCard.css';

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | React.ReactNode;
  accent?: 'primary' | 'success' | 'warning' | 'error';
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  icon,
  label,
  value,
  accent = 'primary'
}) => {
  return (
    <div className={`summary-card summary-card-${accent}`}>
      <div className="summary-card-icon">{icon}</div>
      <div className="summary-card-content">
        <div className="summary-card-label">{label}</div>
        <div className="summary-card-value">{value}</div>
      </div>
    </div>
  );
};
